export default "__VITE_ASSET__DqlPuc3H__"